// import "./license.scss";

class LicenseHandler {
  constructor(modal, options = {}) {
    if (!modal) {
      console.error("modal undefined");
      return;
    }
    const { products = [], prefix, info = {}, db = "pdfposter" } = options;

    this.endpoint = "https://api.bplugins.com/wp-json/license/v1/gumroad";
    this.prefix = prefix;
    this.modal = modal;
    this.info = info;
    this.db = db;

    const opener = document.querySelector(`.${this.prefix}_modal_opener`); //mpafe_modal_opener
    const closer = modal.querySelector(".closer");
    const agree = modal.querySelector(".agree");
    const activateBtn = modal.querySelector(".btn-activate");
    const deactivateBtn = modal.querySelector(".btn-deactivate");
    const loader = modal.querySelector(".bpl_loader");
    this.headers = { "content-Type": "application/json" };
    // this.checking = false;

    window.modal = modal;
    window.license = this;

    if (!opener) console.error("opener not found");
    if (!closer) console.error("closer not found");
    if (!loader) console.error("loader not found");

    opener?.addEventListener("click", (e) => {
      e.preventDefault();
      modal.style.display = "block";
    });

    closer?.addEventListener("click", (e) => {
      e.preventDefault();
      modal.style.display = "none";
    });

    agree?.addEventListener("click", function () {
      activateBtn.disabled = !agree?.checked;
    });

    activateBtn?.addEventListener("click", async (e) => {
      e.preventDefault();
      loader.style.display = "inline-block";
      activateBtn.disabled = true;
      const field = modal.querySelector("input.license_key");
      if (field?.value) {
        const activate = await this.activeLicense(field?.value, products);
        if (activate) {
          this.setNotice("notice-success", "Plugin Activated!, Thank you");
        }
        //  else {
        //   this.setNotice("notice-warning", "Something went wrong!");
        // }
      } else {
        this.setNotice("notice-warning", "Please input a license key");
      }

      activateBtn.disabled = false;
      loader.style.display = "none";
    });

    deactivateBtn?.addEventListener("click", async (e) => {
      e.preventDefault();
      loader.style.display = "inline-block";
      deactivateBtn.disabled = true;

      const field = modal.querySelector("input.license_key");
      if (field?.value) {
        const deactivate = await this.deactiveLicense(field?.value, products);
        if (deactivate) {
          this.setNotice("notice-success", "License key deactivated.");
        }
      }

      deactivateBtn.disabled = false;
      loader.style.display = "none";
    });
  }

  verifyGumroad = async (products = [], key) => {
    let response = {};
    for (let product of products) {
      let res = await fetch("https://api.gumroad.com/v2/licenses/verify", {
        method: "POST",
        headers: { "content-Type": "application/json" },
        body: JSON.stringify({ product_permalink: product, license_key: key }),
      })
        .then((res) => res.json())
        .then((res) => res);
      if (res.success) {
        response = res;
        break;
      }
    }
    const quantity = this.getQuantity(response);
    const isAppSumo = response?.purchase?.product_name?.includes("Sumo") || false;
    const permalink = response?.purchase?.permalink;
    return { quantity, success: response.success, permalink, isAppSumo };
  };

  serverHandler = async (params) => {
    const data = {
      quantity: 1,
      website: window.location?.origin,
      product: this.db,
      email: this.info?.email,
      action: "add",
      ...params,
    };

    const response = await fetch(this.endpoint, {
      method: "POST",
      headers: {
        "content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((res) => res);

    return response;
  };

  activeLicense = async (license_key, products) => {
    const { permalink, success, quantity, isAppSumo } = await this.verifyGumroad(products, license_key);
    if (success) {
      const { active, message } = await this.serverHandler({ license_key, quantity, isAppSumo });
      if (active) {
        const data = new FormData();
        data.append("action", `${this.prefix}_active_license_key`);
        data.append("activated", 1);
        data.append("license_key", license_key);
        data.append("permalink", permalink);
        const activatePlugin = await fetch(this.info?.ajaxUrl, {
          method: "POST",
          body: data,
        })
          .then((res) => res.json())
          .then((res) => res);
        return activatePlugin?.success;
      } else {
        this.setNotice("notice-warning", message);
      }
    } else {
      this.setNotice("notice-warning", "Invalid License key");
    }
  };

  deactiveLicense = async (license_key, products) => {
    const { permalink, success, quantity, isAppSumo } = await this.verifyGumroad(products, license_key);

    if (success) {
      const deactivated = await this.serverHandler({ license_key, action: "deactive" });
      if (deactivated) {
        const data = new FormData();
        data.append("action", `${this.prefix}_active_license_key`);
        data.append("activated", 0);
        data.append("license_key", "");

        const deactivate = await fetch(this.info?.ajaxUrl, {
          method: "POST",
          body: data,
        })
          .then((res) => res.json())
          .then((res) => res);
        return deactivate?.success;
      } else {
        this.setNotice("notice-warning", "something went wrong!");
      }
    } else {
      this.setNotice("notice-warning", "invalid license key!");
    }
  };

  setNotice(classes, noticeText) {
    const noticeParent = this.modal.querySelector(".license_notice");
    const notice = document.createElement("div");
    notice.classList = `notice ${classes}`;
    notice.innerText = noticeText;
    noticeParent.appendChild(notice);
    setTimeout(() => {
      notice.remove();
      if (classes == "notice-success") {
        location.reload();
      }
    }, 3000);

    // setTimeout(() => {
    //   if (classes == "notice-success") {
    //     location.reload();
    //   }
    // }, 1000);
    return;
  }

  getQuantity = (response) => {
    const variants = {
      "(Single Site)": 1,
      "(3 Sites)": 3,
      "(5 Sites)": 5,
      "(Developer  - Unlimited)": 1000,
      "(Developer)": 1000,
    };
    let quantity = variants[response?.purchase?.variants] || 1;

    return quantity;
  };
}

export default LicenseHandler;
